export { default, FORGOT_PASSWORD_PATH } from "./ForgotPasswordPage";
